import gql from 'graphql-tag';

const getFilteredEventsQuery = gql`
  query GetFilteredEvents($filters: EventsFilterInput!) {
    getFilteredEvents(filters: $filters) {
      resourceId
      eventType
    }
  }
`;

const getFilteredEvents = () => ({
  query: getFilteredEventsQuery,
  module: 'history',
  ignoreCache: true,
  buildVariables: (filters) => ({
    filters
  })
});

export default getFilteredEvents;
